import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, inject, input } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'user-profile-element-component',
    templateUrl: './user-profile-element.component.html',
    styleUrls: [
        './user-profile-element.component.css'
    ],
    imports: [RouterOutlet]
})
export class UserProfileElementComponent implements OnInit, OnChanges, OnDestroy {
  private router = inject(Router);

  readonly route = input<string>('');
  readonly token = input<string>('');
  routerSubscription: Subscription = null;
  private readonly ARM_WEB_COMPONENT_READY_KEY = 'armwebcomponent-ready';

  constructor() {
    const router = this.router;

    router.initialNavigation();
    // This is to have the hosting application wait until the arm web component is ready before
    // navigating to the user profile page, otherwise, the arm web component router may not work 
    // and becomes unresponsive. This is set in UserProfileElementComponent and 
    // UserProfileComponent. - kevin.low 05/27/25
    sessionStorage.setItem(this.ARM_WEB_COMPONENT_READY_KEY, 'true');
  }

  ngOnInit(): void {
    const route = this.route();
    const token = this.token();
    if (environment.debug) console.log(`In ArmWebComponent: UserProfileElementComponent.ngOnInit(): this.route=${route}, this.token=${token}`)
    if (route){
      if (route.toLowerCase() === 'contact-verification' || route.toLowerCase() === 'contact-verification/error') {
        if (environment.debug) console.log(`In ArmWebComponent: UserProfileElementComponent.ngOnInit() in if statement: this.route=${route}` + 
                    `,this.token=${token}, \${this.route}/?token=\${this.token}=${route}?token=${token}`);
        this.router.navigateByUrl(`${route.endsWith('/') ? route.slice(0, -1) : route}?token=${token}`);
      }
    }
    else {
      if (environment.debug) console.log(`In ArmWebComponent: UserProfileElementComponent.ngOnInit() in else statement: navigateByUrl=${route.endsWith('/') ? route.slice(0, -1) : route}`);
      this.router.navigateByUrl(route.endsWith('/') ? route.slice(0, -1) : route);
    }

    if (environment.debug) {
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          console.log(`In ArmWebComponent: UserProfileElementComponent: this.router.events.subscribe(event=${event})`);
        }
        if (event instanceof NavigationEnd) {
          console.log(`In ArmWebComponent: UserProfileElementComponent: this.router.events.subscribe(event=${event}, this.route=${this.route()}, this.token=${this.token()})`);
        }
        if (event instanceof NavigationError) {
          console.log(`In ArmWebComponent: UserProfileElementComponent: this.router.events.subscribe(event=${event})`);
        }
        if (event instanceof NavigationCancel) {
          console.log(`In ArmWebComponent: UserProfileElementComponent: this.router.events.subscribe(event=${event})`);
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (environment.debug) console.log('In ArmWebComponent: UserProfileElementComponent.ngOnChanges(changes=', changes, ")");
    if (changes['route']?.currentValue && changes['token']?.currentValue){
      const route = this.route();
      const token = this.token();
      if (environment.debug) console.log(`In ArmWebComponent: UserProfileElementComponent.ngOnChanges(): navigateByUrl=${route}?token=${token}`);
      this.router.navigateByUrl(`${route}?token=${token}`);
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription)
      this.routerSubscription.unsubscribe();
  }
}
